exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "input{width:150px;text-align:center}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/shared/daterange/daterange.component.css"],"names":[],"mappings":"AAAA,MACE,YAAa,iBACM,CACpB","file":"daterange.component.css","sourcesContent":["input{\n  width: 150px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/daterange/daterange.component.css
// module id = zuEl
// module chunks = 6